import { AxiosResponse } from 'axios';
import useSWR from 'swr';

import { apiClient } from '@src/clients';
import { OrderitemReadListResponse } from '@src/clients/clerk/api';
import { sortArrayByDate } from '@src/utils/commonUtils';

export const useOrderItemInCartList = () => {
  const {
    data: { data: { order_items = [] } = {} } = {},
    isValidating,
    isLoading,
    ...rest
  } = useSWR<AxiosResponse<OrderitemReadListResponse>>('in-cart', () =>
    apiClient.clerkApi.v1OrderItemsDraftList({ in_cart: 'true' })
  );

  const items = sortArrayByDate(
    order_items ?? [],
    'created_at'
  ) as typeof order_items;

  return {
    orderItems: items,
    cartCount: items.length,
    isLoading,
    isValidating,
    ...rest
  };
};
